import React from 'react';
import { connect } from 'react-redux';
import properties from '../../constants/Properties';
import storeManager from '../../store/StoreManager';
import apiServiceUtils from '../utils/ApiServiceUtils';
import mouseUtils from '../utils/MouseUtils';
import saveManager from '../utils/SaveManager';
import textSizeUtils from '../utils/TextSizeUtils';
import { changeTextProperties } from '../../actions/CurrentSlideActions';
import { hideMenus, showTextEditor } from '../../actions/MenuActions';
import locales from '../../locales/LocalesManager';
import selectionManager from '../utils/SelectionManager';
import platformDetection from '../utils/PlatformDetection';
import menuType from '../../constants/MenuType';

const Button = React.createClass({
    onButtonClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        var dispatch = storeManager.getStore().dispatch;

        if (this.props.index == 1 && this.props.changeTextContent)
            this.props.changeTextContent();

        dispatch(showTextEditor(undefined));
        dispatch(hideMenus([menuType.ALL_MENUS]));
    },
    render() {
        var textColor;
        var fillColor;

        if (this.props.index == 0) {
            textColor = 'black';
            fillColor = 'white';
        } else {
            textColor = 'white';
            fillColor = properties.DELETE_ALERT_BACKGROUND;
        }

        const buttonStyle = {
            position: 'absolute',
            backgroundColor: fillColor,
            width: 100,
            height: 30,
            top: 10,
            left: this.props.index == 0 ? 30 : undefined,
            right: this.props.index == 1 ? 30 : undefined,
            borderRadius: 3,
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: '#333333',
            cursor: 'pointer',
        };

        const spanStyle = {
            position: 'absolute',
            top: 6,
            fontSize: 16,
            width: buttonStyle.width - 6,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            alignItems: 'center',
            textAlign: 'center',
            cursor: 'pointer',
            color: textColor
        };

        return (
            <div style={buttonStyle} onTouchEnd={this.onButtonClick} onClick={this.onButtonClick}>
                <span style={spanStyle}>{this.props.text}</span>
            </div>
        );
    }
});

const TextEditorContent = React.createClass({
    componentDidMount() {
        document.body.ontouchend = this.changeFocus;
    },
    componentWillReceiveProps(nextProps) {
        if (!this.props.shapeTextModel && nextProps.shapeTextModel)
            this.checkSelection();
    },
    checkSelection() {
        setTimeout(function() {
            var textArea = document.getElementById('textEditorArea');

            if (textArea && textArea.innerText && textArea.innerText.length > 0) {
                var range = document.createRange();
                var sel = window.getSelection();

                range.setStart(textArea.childNodes[0], textArea.innerText.length);
                range.collapse(true)

                sel.removeAllRanges();
                sel.addRange(range);
            }
        }, 20);
    },
    onInputClick() {
        this.changeFocus();
    },
    changeFocus() {
        var textArea = document.getElementById('textEditorArea');

        if (textArea)
            textArea.focus();
    },
    changeTextContent() {
        const newValue = this.refs.textArea.innerText;

        if (newValue == undefined)
            return;

        if (newValue != this.props.shapeTextModel.htmlText) { // change text data
            var dispatch = storeManager.getStore().dispatch;

            dispatch(changeTextProperties(this.props.shapeTextModel, 'htmlText', newValue));
            saveManager.isContentChanged(true);

            setTimeout(this.checkSize, 50, this.props.shapeTextModel.uuid);
        }
    },
    checkSize(uuid) {
        var shapeTextModel = selectionManager.getShapeWithUuid(uuid);
        textSizeUtils.updateTextWrapperSize(shapeTextModel, storeManager.getStore().dispatch, true);

        setTimeout(function() {
            var shape = selectionManager.getShapeWithUuid(uuid);
            textSizeUtils.updateTextWrapperSize(shape, storeManager.getStore().dispatch, false);
        }, 50);
    },
    render() {
        var visible = 'none';

        if (this.props.shapeTextModel)
            visible = 'block';
        else
            return (<div/>);

        const menuStyle = {
            position: 'absolute',
            width: this.props.windowWidth,
            height: this.props.windowHeight,
            top: apiServiceUtils.getNoInternetConnectionAlertHeight(),
            left: 0,
            display: visible,
            zIndex: 20000
        };

        const backgroundStyle = {
            position: 'absolute',
            backgroundColor: properties.DELETE_ALERT_BACKGROUND,
            width: this.props.windowWidth,
            height: this.props.windowHeight,
            top: 0,
            left: 0,
            opacity: 0.7
        };

        const leftGap = 100;
        const topGap = 100;
        var componentStyle = {
            position: 'absolute',
            background: 'white',
            width: this.props.windowWidth - 2 * leftGap,
            height: this.props.windowHeight - 2 * topGap,
            top: 50,
            left: leftGap,
            borderRadius: 15
        };

        if (platformDetection.isIOS() && !platformDetection.isIOSApp())
            componentStyle.top = 10;

        const topBarStyle = {
            position: 'absolute',
            width: componentStyle.width,
            height: 50,
            top: 0,
            left: 0,
            background: '#BDC5C8',
            borderTopLeftRadius: 15,
            borderTopRightRadius: 15
        };

        const titleStyle = {
            position: 'absolute',
            top: 17,
            width: 200,
            left: topBarStyle.width / 2 - 100,
            fontSize: 17,
            fontWeight: 'bold',
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            alignItems: 'center',
            textAlign: 'center',
            cursor: 'default',
            color: 'black'
        };

        const textGap = 20;
        const topAreaStyle = {
            position: 'absolute',
            width: topBarStyle.width - 2 * textGap,
            height: componentStyle.height - topBarStyle.height - 2 * textGap,
            top: topBarStyle.height + textGap / 2,
            padding: textGap / 2,
            left: textGap / 2,
            background: 'white',
            cursor: 'text',
            outline: 'none',
            fontSize: 25,
            whiteSpace: 'pre-line'
        };

        return (
            <div style={menuStyle}>
                <div style={backgroundStyle}/>
                <div style={componentStyle}>
                    <div style={topBarStyle}>
                        <Button dispatch={this.props.dispatch}  index={0} text={locales.getCaption('cancel', 'textEditor')} changeTextContent={this.changeTextContent}/>
                        <Button dispatch={this.props.dispatch}  index={1} text={locales.getCaption('done', 'textEditor')} changeTextContent={this.changeTextContent}/>
                        <span style={titleStyle}>{locales.getCaption('addTextMessage', 'textEditor')}</span>
                    </div>
                    <span className='textShapes' ref='textArea' id='textEditorArea' style={topAreaStyle} contentEditable={true} suppressContentEditableWarning={true} onTouchEnd={this.onInputClick} spellCheck='false' autoCorrect='off' autoCapitalize='off' autoComplete='off'>
                        {this.props.shapeTextModel.htmlText}
                    </span>
                </div>
            </div>
        );
    }
});

function mapStateToProps() {
    const state = storeManager.getState();
    var shapeTextModel = state.menu.textShapeTarget;

    return {
        shapeTextModel
    };
}

export const TextEditor = connect(mapStateToProps)(TextEditorContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/TextEditor.js
 **/